import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { performLogout, listenForCrossTabLogout } from "../utils/logout";

export const getRemainingSessionTime = () => {
  const token = localStorage.getItem("authToken");
  if (!token) return 0;

  try {
    const decoded = jwtDecode(token);

    const remainingTime = decoded.exp * 1000 - Date.now();
    return remainingTime > 0 ? remainingTime : 0;
  } catch (error) {
    return 0;
  }
};

const SessionExpirationHandler = () => {
  useEffect(() => {
    let timer;

    // setTimeout's max safe delay is ~24.86 days (2^31 - 1 ms). For longer
    // expirations, schedule a re-check at the cap; otherwise schedule the
    // logout exactly at the expiry boundary.
    const MAX_DELAY = 2_073_600_000; // 24 days in ms

    const scheduleExpiry = () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      const token = localStorage.getItem("authToken");
      if (!token) return;
      const remainingTime = getRemainingSessionTime();
      if (remainingTime <= 0) {
        performLogout();
        return;
      }
      if (remainingTime > MAX_DELAY) {
        timer = setTimeout(scheduleExpiry, MAX_DELAY);
      } else {
        timer = setTimeout(performLogout, remainingTime);
      }
    };

    // Re-check on tab visibility — handles system suspend/resume where the
    // monotonic timer would have drifted behind wallclock.
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        scheduleExpiry();
      }
    };

    scheduleExpiry();
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Listen for logout signals from other tabs (BroadcastChannel + storage event)
    const cleanupCrossTab = listenForCrossTabLogout();

    return () => {
      if (timer) clearTimeout(timer);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      cleanupCrossTab();
    };
  }, []);

  return null;
};

export default SessionExpirationHandler;
